import { render, staticRenderFns } from "./forumList.vue?vue&type=template&id=49da642c&scoped=true"
import script from "./forumList.vue?vue&type=script&lang=js"
export * from "./forumList.vue?vue&type=script&lang=js"
import style0 from "./forumList.vue?vue&type=style&index=0&id=49da642c&prod&lang=scss&scoped=true"
import style1 from "./forumList.vue?vue&type=style&index=1&id=49da642c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49da642c",
  null
  
)

export default component.exports